var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeFloatingPanel,
          expression: "closeFloatingPanel",
        },
      ],
      staticClass: "tilt-picker",
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "tilt-trigger",
          class: { "is-open": _vm.isOpen, "has-tilt": _vm.tilt !== 0 },
          attrs: { title: `Tilt: ${_vm.displayTilt} deg` },
          on: { click: _vm.toggleFloatingPanel },
        },
        [
          _c("i", { staticClass: "bi bi-arrow-clockwise" }),
          _vm._v(" "),
          _vm.tilt !== 0
            ? _c("span", { staticClass: "tilt-trigger__value" }, [
                _vm._v("\n      " + _vm._s(_vm.displayTilt) + " °\n    "),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "tilt-panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                ref: "panel",
                staticClass: "tilt-panel",
                style: _vm.floatingPanelStyle,
                attrs: { role: "dialog", "aria-label": "Tilt control" },
              },
              [
                _c("div", { staticClass: "tilt-panel__head" }, [
                  _c("span", { staticClass: "tilt-panel__title" }, [
                    _vm._v("Tilt"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "tilt-panel__reset",
                      class: { "is-active": _vm.tilt !== 0 },
                      attrs: { disabled: _vm.tilt === 0 },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("\n          Reset\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tilt-presets" },
                  _vm._l(_vm.presets, function (preset) {
                    return _c(
                      "button",
                      {
                        key: preset,
                        staticClass: "tilt-preset",
                        class: { "is-selected": _vm.tilt === preset },
                        on: {
                          click: function ($event) {
                            return _vm.selectPreset(preset)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(preset > 0 ? `+${preset}` : preset) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tilt-slider-wrap" }, [
                  _c("input", {
                    staticClass: "tilt-slider",
                    attrs: {
                      type: "range",
                      min: _vm.min,
                      max: _vm.max,
                      step: _vm.step,
                    },
                    domProps: { value: _vm.tilt },
                    on: { input: _vm.onSlider },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tilt-slider-fill",
                    style: _vm.fillStyle,
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "tilt-grade ml-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.displayTilt > 0
                          ? `+${_vm.displayTilt}`
                          : _vm.displayTilt
                      ) + " deg"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "tilt-panel__apply-all",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("apply-all", _vm.tilt)
                      },
                    },
                  },
                  [_vm._v("\n        Apply to all shelves\n      ")]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }